import { render, staticRenderFns } from "./ipd_reports.vue?vue&type=template&id=5019bf45&scoped=true"
import script from "./ipd_reports.vue?vue&type=script&lang=js"
export * from "./ipd_reports.vue?vue&type=script&lang=js"
import style0 from "./ipd_reports.vue?vue&type=style&index=0&id=5019bf45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019bf45",
  null
  
)

/* custom blocks */
import block0 from "./ipd_reports.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports